export default __webpack_public_path__ + "static/media/Group 1489.ec88b4f2.png";